module.exports = __webpack_public_path__ + "static/sabin-handsopen-75ab43af54c6878e613d74c5682005dc.png";